export default "__VITE_ASSET__C363PNFR__"